<template>
  <div class="addcomment" v-if="seen">
    <div class="commentbox">
      <div class="close">
        <span class="success" v-if="success"> Comment saved... </span>
        <span class="close-box" @click="close">
          <svg style="width: 18px; height: 18px" viewBox="0 0 24 24">
            <path
              fill="#FC6D6C"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </svg>
        </span>
      </div>
      <div class="name">
        <strong>{{ str_text(name) }}</strong>
      </div>
      <div class="comments">
        <div class="comment-text">
          <div class="body">
            <div class="profile-pix">
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path
                  fill="#000000"
                  d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z"
                />
              </svg>
            </div>
            <div class="text">
              <div class="top">
                <div class="name">
                  {{ comment.name }}
                </div>
                <div class="comment">
                  {{ comment.comment }}
                </div>
              </div>
              <div class="reply-comment"></div>
              <div class="footer">
                <span>Reply</span
                ><span class="date">{{ timeAgo(comment.createdAt) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="top">
          <div class="textfield">
            <div
              class="comment"
              :class="{ error: error }"
              ref="comment"
              contenteditable="true"
              placeholder="Add a comment"
              @focus="fint"
            ></div>
            <div class="send" @click="sendcomment">
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path fill="#ccc" d="M2,21L23,12L2,3V10L17,12L2,14V21Z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.name {
  text-align: left;
}
</style>

<script>
import { setTimeout } from "timers";
import { mapMutations } from "vuex";
import moment from "moment";
import cookies from "@/services/cookies";

export default {
  data() {
    return {
      seen: false,
      name: "",
      id: "",
      comment: "",
      error: false,
      loader: false,
      success: false,
      fint_text: true,
      base: false,
    };
  },
  methods: {
    ...mapMutations([
      "UPDATE_PREVIEW_COMMENT",
      "UPDATE_TOTAL_COMMENT",
      "UPDATE_COMMENTS",
      "UPDATE_COMMENTS_LIST",
      "EMPTY_FILE_ACTION",
    ]),
    timeAgo(time) {
      return moment(time).fromNow(); // 8 years ago
    },
    fint(evt) {
      this.error = false;
    },
    str_text(str) {
      return str.length > 38 ? str.substr(0, 38) + "..." : str;
    },
    logincall() {
      this.$parent.logincall();
    },
    load(name, comment) {
      this.loader = false;
      this.id = id;
      this.name = name;
      this.seen = true;
    },
    sendcomment() {
      if (this.$refs.comment.innerText === "") {
        this.error = true;
      } else {
        this.loader = true;
        let that = this;

        let data = {
          token: cookies.getCookie("token"),
          id: this.id,
          comment: this.$refs.comment.innerText,
          limit: true,
        };

        this.$socket.emit("addcomment", data, function (data) {
          if (data.message === "completed") {
            that.$refs.comment.innerText = "";
            that.loader = false;
            that.success = true;
            that.comment = "";
            that.UPDATE_COMMENTS_LIST(data.comments[0]);
            that.UPDATE_PREVIEW_COMMENT(data.comments);
            that.UPDATE_TOTAL_COMMENT(data.comments_total);

            if (that.base === true) {
              let index =
                that.$store.getters.GET_FILES_INDEX[
                  that.$store.getters.GET_FILE_ACTION[0]
                ];
              let name = (that.$store.getters.DIRECTORY_CHILDREN[
                index
              ].is_checked = false);

              that.EMPTY_FILE_ACTION();
            }

            setTimeout(() => {
              that.success = false;
            }, 3000);
          }

          if (data.data === false) {
            that.seen = false;
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    close() {
      this.seen = false;
      this.comment = "";
      this.loader = false;
    },
  },
};
</script>
